import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getRoutePartners, getWareHouses } from "../../../../helper/functions";
import {
  setSelectedRequest,
  setSelectedPackage,
} from "../../../../store/commonSlice";

/**
 * Custom hook to manage package filters (route partners and warehouses)
 * @returns {Object} Filter state and handlers
 */
export const usePackagesFilters = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.value);
  const [selectedFilters, setSelectedFilters] = useState({
    routePartnerId: "",
    warehouseId: "",
  });
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });

  // Fetch route partners on mount
  const getRoutePartner = async () => {
    try {
      const routerPartners = await getRoutePartners([
        {
          key: "isDeleted",
          operator: "==",
          value: false,
        },
      ]);
      setFilterOptions({ routePartners: routerPartners, warehouses: [] });
      console.log(routerPartners, "routePartner");
    } catch (error) {
      console.error("Error fetching route partners:", error);
    }
  };

  // Fetch warehouses based on route partner
  const getWarehouse = async (routerPartnerId) => {
    if (routerPartnerId) {
      try {
        const data = await getWareHouses({ routePartnerId: routerPartnerId });
        console.log(data, "routePartnerId");
        setFilterOptions((prev) => ({ ...prev, warehouses: data }));
      } catch (error) {
        console.error("Error fetching warehouses:", error);
      }
    }
  };

  // Handle filter changes
  const changeFilterHandler = async (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    dispatch(setSelectedRequest(null));
    dispatch(setSelectedPackage(null));
    getWarehouse(filter?.routePartnerId);
  };

  // Initialize route partners on mount
  useEffect(() => {
    getRoutePartner();
  }, []);

  // Set default filter if user has routePartnerId
  useEffect(() => {
    if (user?.routePartnerId) {
      setSelectedFilters((prev) => ({
        ...prev,
        routePartnerId: user?.routePartnerId,
      }));
      getWarehouse(user?.routePartnerId);
    }
  }, [user]);

  return {
    selectedFilters,
    filterOptions,
    changeFilterHandler,
  };
};

